// @core/api/endpoints/attachment/get_attachment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachmentResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Get attachment by ID
 * Retrieves attachment metadata including file name, size, MIME type, processing status, and optionally a fresh presigned download URL.
 */
export async function GetAttachment(
  attachment_id: string,
  options?: RequestOptions
): Promise<AttachmentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/:attachment_id`;
  requestPath = requestPath.replace(':attachment_id', encodeURIComponent(attachment_id));
  const requestOptions = options;
  return client.get<AttachmentResponse>(requestPath, { ...requestOptions });
}
